<template>
    <v-container pa-0 ma-0 fluid>
        <v-row>
            <v-col cols="12">

                <h1 class="text-center mb-5">{{$t('components.checks.mic.title')}}</h1>

                <p v-if="!permission">
                    {{$t('components.checks.mic.permission_error')}}
                </p>

                <v-row justify="center" align="center" style="min-height: 300px;">
                    <v-icon style="position: absolute; font-size: 30px; z-index: 2;">
                        mdi-microphone
                    </v-icon>
                    <div class="expanding-circle-center"></div>
                    <div class="expanding-circle" :style="expandingCircleStyle"></div>
                    <div class="expanding-circle-min" :style="minCircleStyle"></div>
                </v-row>

                <v-row justify="center">

                    <v-autocomplete :items="audioInputDevices"
                                    class="mb-5"
                                    hide-details
                                    item-color="white"
                                    item-text="label"
                                    item-value="deviceId"
                                    :label="$t('components.checks.mic.mic')"
                                    light
                                    :no-data-text="$t('components.checks.no_devices')"
                                    prepend-inner-icon="mdi-microphone"
                                    solo
                                    :value="selectedAudioInputDevice"
                                    @change="setAudioInputDevice($event)"
                                    style="max-width: 500px !important;"
                    ></v-autocomplete>

                </v-row>


                <p v-if="!soundFound && !displayError" class="text-center">
                  {{$t('components.checks.mic.say')}}

                </p>

                <p v-else-if="displayError" class="text-center">
                  {{$t('components.checks.mic.nohear')}}
                </p>


                <v-row justify="center">
                    <v-btn :disabled="!soundFound || displayError" @click="next()" color="primary">{{$t('general.continue')}}</v-btn>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import {configureDevices} from "../../lib/mediaDevices";
    import audioInputMixin from "../../components/settings/audioInputMixin";

    export default {
        name: "MicCheck",
        mixins: [audioInputMixin],
        components: {},
        data() {
            return {
                audioInputDevices: null,
                permission: true,
                soundFound: false,
                minCircleStyle: {},
                expandingCircleStyle: {},
                micTimeout: null,
                displayError: false
            }
        },
        mounted() {
            this.listenForPermission();
            this.getSystemDevices();
            this.initAudioContext();
            this.monitorSoundFound();
        },
        methods: {
          listenForPermission(){
            navigator.permissions.query({ name: 'microphone' }).then((notificationPerm)=>{
              notificationPerm.onchange = ()=>{
                this.getSystemDevices();
              };
            });
          },
            getSystemDevices() {
                navigator.mediaDevices.enumerateDevices()
                    .then((devices) => {
                            this.audioInputDevices = devices.filter(d => d.kind === 'audioinput');
                            configureDevices(false, true, false);
                            this.startAudioInputStream();
                        },
                        () => {
                            this.permission = false;
                        });
            },
            setAudioInputDevice(val) {
                this.soundFound = false;
                this.stopAudioInputStream();
                this.$store.dispatch('media/setAudioInputDevice', val).then(() => {
                    this.initAudioContext();
                    this.startAudioInputStream();
                });
            },
            next() {
                this.$router.push({name: 'SoundCheck'});
            },
            monitorSoundFound() {
                let soundFoundBuffer = 0;
                this.$watch('audioStreamValue', (val) => {
                    this.calcStyles(val);
                    if (this.soundFound) return;
                    if (this.audioStreamValue >= 5) {
                        soundFoundBuffer++;
                    }
                    if (soundFoundBuffer > 5) {
                        this.soundFound = true;
                    }
                });
                this.$watch('soundFound', () => {
                    soundFoundBuffer = 0;
                });
            },
            calcStyles(val) {
                let diameter, color;
                clearTimeout(this.micTimeout);
                if (val > 0) {
                    if (val <= 5) {
                        diameter = 105 + (10 * val);
                        color = 'rgba(255, 255, 255, 0.1)';

                    } else if (val > 5) {
                        diameter = 155 + (2 * (val - 5));
                        color = 'rgba(76, 175, 80, 0.4)';
                    }
                    this.displayError = false;
                    this.setStyles(diameter, color);
                } else if (val === 0) {
                    this.micTimeout = setTimeout(() => {
                        diameter = 105;
                        color = 'rgba(152, 7, 36, 0.6)';
                        this.setStyles(diameter, color);
                        this.displayError = true;
                    }, 3000);
                }
            },
            setStyles(diameter, color) {
                this.minCircleStyle = {'border-color': color};
                this.expandingCircleStyle = {
                    width: diameter + 'px',
                    height: diameter + 'px',
                    'background-color': color
                };
            }
        }
    }
</script>

<style scoped>
    .webcam-container {
        position: relative;
        background-color: black;
        border-radius: 10px;
        box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
        overflow: hidden;
    }

    .webcam-container .webcam-window {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        border-radius: 10px;
    }

    .webcam-container .overlay-center {
        font-family: Roboto, sans-serif;
        font-size: 30pt;
        color: white;
        background-color: black;
        opacity: 0.3;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
    }

    .expanding-circle-center {
        width: 80px;
        height: 80px;
        border-radius: 100%;
        background-color: rgba(255, 255, 255, 0.2);
        z-index: 1;
    }

    .expanding-circle {
        position: absolute;
        min-width: 105px;
        min-height: 105px;
        border-radius: 100%;
        background-color: rgba(255, 255, 255, 0.1);
        transition: width .5s ease, height .5s ease;
    }

    .expanding-circle-min {
        width: 155px;
        height: 155px;
        border-radius: 100%;
        border: 0.5px solid;
        border-color: rgba(255, 255, 255, 0.1);
        position: absolute;
    }
</style>